import { UserManager } from "oidc-client";

const trimSlash = (value) => (value || "").replace(/\/+$/, "");

const appOrigin = window.location.origin;
const authority = trimSlash(process.env.REACT_APP_API_BASE_URL || "");

const settings = {
  authority,
  client_id: "google-auth-demo",
  redirect_uri: `${appOrigin}/auth-callback`,
  // Do not set post_logout_redirect_uri here: oidc-provider requires id_token_hint
  // when it is present. We pass it only from logout() when we have a stored id_token.
  response_type: "code",
  scope: "openid email profile",
};

export const userManager = new UserManager(settings);

export const logout = (idTokenHint) => {
  if (idTokenHint) {
    return userManager.signoutRedirect({
      id_token_hint: idTokenHint,
      post_logout_redirect_uri: `${appOrigin}/`,
    });
  }
  // End session at provider without post_logout_redirect_uri (not allowed without hint).
  return userManager.signoutRedirect({});
};

export const completeLogout = () => userManager.signoutRedirectCallback();
